import React from 'react';
import { Typography } from '@wds/typography';
import { T } from '@sm/intl';
import COPY from './Copy';
import useStyles from './useStyles';

const FiveHundredError = () => {
  const {
    wrapper,
    messageWrapper,
    messageContainer,
    linksContainer,
    linksList,
    linksListItem,
  } = useStyles();

  return (
    <div className={wrapper} data-testid="FiveHundredError">
      <div className={messageWrapper}>
        <Typography variant="pageTitle" align="center">
          <T desc={COPY.SORRY_MESSAGE} />
        </Typography>
        <div className={messageContainer}>
          <Typography variant="sectionTitle" align="center">
            <T desc={COPY.SOMETHING_WRONG} />
          </Typography>
          <Typography component="div" variant="body" align="center" p={1}>
            <p>
              <T desc={COPY.FIVE_HUNDRED_MESSAGE} />
            </p>
          </Typography>
          <div className={linksContainer}>
            <ul className={linksList}>
              <li className={linksListItem}>
                <a href="/">
                  <T desc={COPY.HOME} />
                </a>
              </li>
              <li className={linksListItem}>
                <a href="/mp/sitemap/">
                  <T desc={COPY.SITEMAP} />
                </a>
              </li>
              <li className={linksListItem}>
                <a href="https://help.surveymonkey.com/">
                  <T desc={COPY.HELP_CENTER} />
                </a>
              </li>
              <li className={linksListItem}>
                <a href="/mp/survey-templates/">
                  <T desc={COPY.TEMPLATES} />
                </a>
              </li>
              <li className={linksListItem}>
                <a href="/mp/take-a-tour/">
                  <T desc={COPY.LEARN_MORE} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FiveHundredError;
